import { Ring } from "@uiball/loaders";
import PropTypes from "prop-types";

import { colors } from "../../consts";
import { withTooltip } from "../../hoc";
import { SmallButtonStyled } from "./styled";

const SmallButton = ({ children, loading, ...props }) => {
  return (
    <SmallButtonStyled {...props}>
      {loading ? (
        <Ring
          size={24}
          lineWeight={5}
          speed={2}
          color={props?.secondary ? colors.RAISIN_100 : colors.WHITE}
        />
      ) : (
        children
      )}
    </SmallButtonStyled>
  );
};

SmallButton.propTypes = {
  children: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  secondary: PropTypes.bool
};

export default withTooltip(SmallButton);
